import React from "react";
import "./App.css";
import RoutesModule from "./Routes";

function App() {
  return (
    <div className="App">
      <RoutesModule />
    </div>
  );
}

export default App;
